/**
 * created by yxy
 *
 */

/**
 * 分类组件
 */
import React, {Component} from 'react';
import Step from './Step'

import { Modal } from 'antd';
import {uuid} from "../../../utils";

export default class SetUp extends Component {
    // 默认属性
    static defaultProps = {

    };
    // 静态类型分析
    static propTypes = {

    };
    constructor(props) {
        super(props);
        this.state = {warehousing:false}
    }
    stepKey = uuid();

    show(){
        this.stepKey = uuid();
        this.state.warehousing= true;
    }
    componentDidMount() {

    }
    close=()=>{
        this.props.callbackData();
        this.setState({warehousing: false});
    }
    //关闭工具箱的弹框
    handleCancel = e => {
        this.setState({warehousing:false});
    };
    render() {

        return (
            <Modal
                title="上传设置"
                visible={this.state.warehousing}
                onOk={this.handleOk}
                width={'70%'}
                centered
                maskClosable={false}
                footer={null}
                onCancel={this.handleCancel}>
                <Step close={()=>this.close()} key={this.stepKey} resourceType={this.props.resourceType} resourceId ={this.props.resourceId}/>
            </Modal>
        );
    }
}
